export default __webpack_public_path__ + "static/media/kanta_identification.fc2aaeb5.png";